module.exports = __webpack_public_path__ + "static/media/flag-grey.53869330.svg";